export default "__VITE_ASSET__D0BRHN69__"